import { Stack, TextField, Typography } from '@mui/material'
import { FieldDef } from '../types'

interface RangeVal {
  low: number
  high: number
  currency?: string
}

interface Props {
  field: FieldDef
  value: RangeVal
  onChange: (v: RangeVal) => void
}

export default function NumberRangeWidget({ field, value, onChange }: Props) {
  const safe: RangeVal = value || { low: 0, high: 0, currency: 'USD' }

  return (
    <Stack spacing={1}>
      <Typography variant="caption" color="text.secondary">
        {field.label}
      </Typography>
      <Stack direction="row" spacing={1} alignItems="center">
        <TextField
          type="number"
          label="Low"
          value={safe.low ?? ''}
          onChange={(e) => onChange({ ...safe, low: e.target.value === '' ? 0 : Number(e.target.value) })}
          size="small"
          sx={{ width: 130 }}
        />
        <Typography variant="body2" color="text.secondary">
          —
        </Typography>
        <TextField
          type="number"
          label="High"
          value={safe.high ?? ''}
          onChange={(e) => onChange({ ...safe, high: e.target.value === '' ? 0 : Number(e.target.value) })}
          size="small"
          sx={{ width: 130 }}
        />
        <TextField
          label="Currency"
          value={safe.currency || 'USD'}
          onChange={(e) => onChange({ ...safe, currency: e.target.value.toUpperCase() })}
          size="small"
          sx={{ width: 90 }}
        />
      </Stack>
    </Stack>
  )
}
